import React from 'react'
import UserCard from './UserCard.jsx'

const Stewart = () =>
  <UserCard
    name="Stewart"
    title="Founder"
    dyk="Stewart has an incredibly messy desk, and a CD collection that is in perfect alphabetical order. It drives everybody mad. Including him."
  >
    <p>
      Stewart founded Lenses for Hire in 2008 when he wanted a big lens to
      photograph polar bears without getting up close and personal. He built
      a website and started operations from his spare room, but when it got
      to the stage where even the sofa was piled with lenses he moved it into
      our current offices in Maidenhead. He oversaw the growth of the
      business for the next 12 years until 2020 when Richie offered to buy
      him out. With the future of the business secured, he's looking forward
      to spending more time hiking, rowing, cooking, and pandering to his
      cat.
    </p>
  </UserCard>

export default Stewart